import {AfterViewInit, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {RoutingDemoPageService} from '../services/routing-demo-page-service';
import {ErrorDialogService} from '../services/error-dialog.service';
import {marker} from 'leaflet/dist/leaflet.js';
import * as L from 'leaflet';
import contains = Microsoft.Maps.SpatialMath.Geometry.contains;

export enum timeUnits {
  Minutes = 'min',
  Hours = 'h'
}

export enum distanceUnits {
  Miles = 'mi',
  Kilometers = 'km'
}

export enum GEOMETERS {
  '#996600',
  '#FF4500',
  '#006699',
  '#FF7F50',
  '#663300',
  '#00ffff',
  '#00008B',
  '#8B008B',
  '#8B0000',
  '#2d2d1f',
  '#00FF00',
  '#ffcc00',
  '#556B2F',
  '#0000ff',
  '#ff00bf',
  length
}

export enum HistoricTrafficTimeBuckets {
  None = 'none',
  'AM Peak' = 'ampeak',
  'PM Peak' = 'pmpeak',
  'Off Peak' = 'offpeak',
  'Night Time' = 'night'
}

export enum heightUnits {
  Meter = 'meter',
  Foot = 'foot'
}

export enum widthUnits {
  Meter = 'meter',
  Foot = 'foot'
}

export enum lengthUnits {
  Meter = 'meter',
  Foot = 'foot'
}

export enum weightUnits {
  Kilogram = 'Kilogram',
  Pound = 'Pound',
  'Metric Tonnes' = 'Metric Tonnes',
  Ton = 'Ton'
}

export enum vehicleTypes {

  ALL = 'ALL',
  STRAIGHT = 'STRAIGHT',

  SEMI_TRAILOR = 'SEMI_TRAILOR',

  STANDARD_DOUBLE = 'STANDARD_DOUBLE',

  INTERMEDIATE_DOUBLE = 'INTERMEDIATE_DOUBLE',

  LONG_DOUBLE = 'LONG_DOUBLE',

  TRIPLE = 'TRIPLE',

  OTHER_LONG_COMBINATION_VEHICLE = 'OTHER_LONG_COMBINATION_VEHICLE'
}

export enum localRoadsLoadFactors {


  // @ts-ignore
  '1' = '1',
  // @ts-ignore
  '2' = '2',
  // @ts-ignore
  '3' = '3'
}

export enum directionLanguages {

  English = 'en',
  'English US' = 'en_US',
  Danish = 'da',
  German = 'de',
  Spanish = 'es',
  Finnish = 'fi',
  French = 'fr',
  Italian = 'it',
  Japanese = 'ja',
  Dutch = 'nl',
  Norwegian = 'no',
  Portuguese = 'pt',
  Russian = 'ru',
  Swedish = 'sv',
  Turkish = 'tr',
  Slovak = 'sk',
  Hungarian = 'hu',
  Lithuania = 'lt',
  Estonia = 'et',
  Slovenia = 'sl',
  Latvia = 'lv',
  Croatia = 'hr',
  Romania = 'ro',
  Czech = 'cs',
  'Chinese Taiwan' = 'zh_TW',
  'Simplified Chinese' = 'zh_CN',
  Albanian = 'sq'
}

@Component({
  selector: 'app-route',
  templateUrl: './route.component.html',
  styleUrls: ['./route.component.css']
})
export class RouteComponent implements OnInit, AfterViewInit {
  @Input() selectedDBName: string;
  @Input() username: string;
  @Input() password: string;
  private appliedRoute: boolean;
  private restRouteRequest: string;
  private methodType: string;
  private routeInstructions: string;
  private requestPostBody: string;
  private testStartlong: boolean;
  private testStartlat: boolean;
  private testEndlong: boolean;
  private testEndlat: boolean;
  private invalidEndLong: boolean;
  private invalidEndLat: boolean;
  private testwidth: boolean;
  private testheight: boolean;
  private testlength: boolean;
  private testweight: boolean;
  private user: any;
  private userPasswod: any;

  constructor(private routingDemoPageService: RoutingDemoPageService, private ref: ChangeDetectorRef,
              private errorDialogService: ErrorDialogService) {
  }
  longreg = new RegExp(/^-?(\d*\.)?\d*$/);
  latreg = new RegExp(/^-?(\d*\.)?\d*$/);
  cvrreg = new RegExp(/[~!@#$%^&*(\\\/\-['`;=+\]), "?:{}|<>_]/);
  point1x: any;
  private invalidLong: boolean;
  point1y: any;
  invalidLat: boolean;
  point1coordsys: any;
  point2x: any;
  point2y: any;
  point3x: any;
  point3y: any;
  point2coordsys: any;
  points = '';
  optimizeBy: string;
  point3coordsys: any;
  selectedHistoricTimeBucketB: any;
  bucketUnits: any[];
  oip: boolean;
  selectedDistanceUnit: any;
  distUnits: any[];
  primaryNameOnly: boolean;
  selectedTimeUnit: any;
  tmUnits: any[];
  majorRoadsOnly: boolean;
  selectedLanguage: any;
  lang: any[];
  directionsStyle: string;
  selectedLocalRoadsLoadFactor: any;
  factor: any[];
  avoidTollRoads: boolean;
  isUseCVROptions: boolean;
  selectLooseningBarrierRestriction: string;
  selectedVehicleTypes: any;
  speedUnits: any[];
  height: any;
  invalidheight: boolean;
  selectedHeightUnits: any;
  heightUnits: any[];
  length: any;
  invalidLength: boolean;
  selectedLengthUnits: any;
  lengthUnits: any[];
  weight: any;
  invalidweight: boolean;
  selectedWeightUnits: any;
  weightUnits: any[];
  width: any;
  invalidwidth: boolean;
  selectedWidthUnits: any;
  widthUnits: any[];
  isApplyButtonDisabled: boolean;
  isDisabled: boolean;
  showRouteReqDiv: boolean;
  private appliedDirection: boolean;
  private type: string;
  private crstype: string;
  private epsg: string;
  map = this.routingDemoPageService.map;
  layerGroups = this.routingDemoPageService.layerGroup;
  dataCleared = false;
  mapCleared = false;

  ngOnInit() {
    this.map = this.routingDemoPageService.map;
    this.layerGroups = this.routingDemoPageService.layerGroup;
    this.isDisabled = true;
    this.appliedDirection = false;
    this.optimizeBy = 'time';
    this.oip = false;
    this.primaryNameOnly = false;
    this.majorRoadsOnly = false;
    this.showRouteReqDiv = false;
    this.directionsStyle = 'None';
    this.selectLooseningBarrierRestriction = 'n';
    this.type = 'MultiPoint';
    this.crstype = 'name';
    this.epsg = 'epsg:4326';
    this.historicbucket();
    this.disUnits();
    this.timUnits();
    this.Language();
    this.loadFactor();
    this.vehicleType();
    this.hunits();
    this.lUnits();
    this.wUnits();
    this.wiUnits();

  }

  ngAfterViewInit() {
    this.setMapContentForRoute();
    this.ref.detectChanges();
  }

  validateStartLongitude() {
    this.testStartlong = this.longreg.test(this.point1x);
    if (this.testStartlong === false) {
      this.invalidLong = this.testStartlong;
    } else {
      this.invalidLong = true;
    }
  }

  validateStartLatitude() {
    this.testStartlat = this.latreg.test(this.point1y);
    if (this.testStartlat === false) {
      this.invalidLat = this.testStartlat;
    } else {
      this.invalidLat = true;
    }
  }
  validateEndLongitude() {
    this.testEndlong = this.longreg.test(this.point2x);
    if (this.testEndlong === false) {
      this.invalidEndLong = this.testEndlong;
    } else {
      this.invalidEndLong = true;
    }
  }

  validateEndLatitude() {
    this.testEndlat = this.latreg.test(this.point2y);
    if (this.testEndlat === false) {
      this.invalidEndLat = this.testEndlat;
    } else {
      this.invalidEndLat = true;
    }
  }

  validateHeight() {
    this.testheight = this.cvrreg.test(this.height);
    if (this.testheight === false) {
      this.invalidheight = this.testheight;
    } else {
      this.invalidheight = true;
    }
  }

  validateLength() {
    this.testlength = this.cvrreg.test(this.length);
    if (this.testlength === false) {
      this.invalidLength = this.testlength;
    } else {
      this.invalidLength = true;
    }
  }

  validateweight() {
    this.testweight = this.cvrreg.test(this.weight);
    if (this.testweight === false) {
      this.invalidweight = this.testweight;
    } else {
      this.invalidweight = true;
    }
  }

  validateWidth() {
    this.testwidth = this.cvrreg.test(this.width);
    if (this.testwidth === false) {
      this.invalidwidth = this.testwidth;
    } else {
      this.invalidwidth = true;
    }
  }

  setOptimizeBy(value: string) {
    this.optimizeBy = value;
  }

  historicbucket() {
    const arrayObjects = [];
    for (const [propertyKey, propertyValue] of Object.entries(HistoricTrafficTimeBuckets)) {
      arrayObjects.push({id: propertyValue, name: propertyKey});
    }
    this.bucketUnits = arrayObjects;
    this.selectedHistoricTimeBucketB = this.bucketUnits[0].id;
  }

  onChangeBucket(event: any) {
    const value = this.selectedHistoricTimeBucketB;
    this.selectedHistoricTimeBucketB = value;
  }

  disUnits() {
    const arrayObjects = [];
    for (const [propertyKey, propertyValue] of Object.entries(distanceUnits)) {
      arrayObjects.push({id: propertyValue, name: propertyKey});
    }
    this.distUnits = arrayObjects;
    this.selectedDistanceUnit = this.distUnits[0].id;
  }

  onChangeDistanceUnit(event: any) {
    const value = this.selectedDistanceUnit;
    this.selectedDistanceUnit = value;
  }

  timUnits() {
    const arrayObjects = [];
    for (const [propertyKey, propertyValue] of Object.entries(timeUnits)) {
      arrayObjects.push({id: propertyValue, name: propertyKey});
    }
    this.tmUnits = arrayObjects;
    this.selectedTimeUnit = this.tmUnits[0].id;
  }

  onChangeTimeUnit(event: any) {
    const value = this.selectedTimeUnit;
    this.selectedTimeUnit = value;
  }

  Language() {
    const arrayObjects = [];
    for (const [propertyKey, propertyValue] of Object.entries(directionLanguages)) {
      arrayObjects.push({id: propertyValue, name: propertyKey});
    }
    this.lang = arrayObjects;
    this.selectedLanguage = this.lang[0].id;
  }

  onChangeLanguage(event: any) {
    const value = this.selectedLanguage;
    this.selectedLanguage = value;
  }

  isReturnDirections() {
    if (this.directionsStyle === 'None') {
      return true;
    }
  }

  loadFactor() {
    const arrayObjects = [];
    for (const [propertyKey, propertyValue] of Object.entries(localRoadsLoadFactors)) {
      arrayObjects.push({id: propertyValue, name: propertyKey});
    }
    this.factor = arrayObjects;
    this.selectedLocalRoadsLoadFactor = this.factor[0].id;
  }

  onChangeFactor(event: any) {
    const value = this.selectedLocalRoadsLoadFactor;
    this.selectedLocalRoadsLoadFactor = value;
  }

  vehicleType() {
    const arrayObjects = [];
    for (const [propertyKey, propertyValue] of Object.entries(vehicleTypes)) {
      arrayObjects.push({id: propertyValue, name: propertyKey});
    }
    this.speedUnits = arrayObjects;
    this.selectedVehicleTypes = this.speedUnits[0].id;
  }

  onChangeVehicle(event: any) {
    const value = this.selectedVehicleTypes;
    this.selectedVehicleTypes = value;
  }

  hunits() {
    const arrayObjects = [];
    for (const [propertyKey, propertyValue] of Object.entries(heightUnits)) {
      arrayObjects.push({id: propertyValue, name: propertyKey});
    }
    this.heightUnits = arrayObjects;
    this.selectedHeightUnits = this.heightUnits[0].id;
  }

  onChangeheightUnits(event: any) {
    const value = this.selectedHeightUnits;
    this.selectedHeightUnits = value;
  }

  lUnits() {
    const arrayObjects = [];
    for (const [propertyKey, propertyValue] of Object.entries(lengthUnits)) {
      arrayObjects.push({id: propertyValue, name: propertyKey});
    }
    this.lengthUnits = arrayObjects;
    this.selectedLengthUnits = this.lengthUnits[0].id;
  }

  onChangeLengthUnits(event: any) {
    const value = this.selectedLengthUnits;
    this.selectedLengthUnits = value;
  }

  wUnits() {
    const arrayObjects = [];
    for (const [propertyKey, propertyValue] of Object.entries(weightUnits)) {
      arrayObjects.push({id: propertyValue, name: propertyKey});
    }
    this.weightUnits = arrayObjects;
    this.selectedWeightUnits = this.weightUnits[0].id;
  }

  onChangeWeightUnits(event: any) {
    const value = this.selectedWeightUnits;
    this.selectedWeightUnits = value;
  }

  wiUnits() {
    const arrayObjects = [];
    for (const [propertyKey, propertyValue] of Object.entries(widthUnits)) {
      arrayObjects.push({id: propertyValue, name: propertyKey});
    }
    this.widthUnits = arrayObjects;
    this.selectedWidthUnits = this.widthUnits[0].id;
  }

  onChangeWidthUnits(event: any) {
    const value = this.selectedWidthUnits;
    this.selectedWidthUnits = value;
  }

  isPostRequest() {
    const isUseCVR = this.isUseCVROptions;
    const UseIntermediate = this.points;
    if (isUseCVR) {
      return true;
    } else if (UseIntermediate) {
      return true;
    } else if (isUseCVR && UseIntermediate) {
      return true;
    } else {
      return false;
    }
  }

  clearAll() {
    this.clearData();
    this.clearMap();
    this.isDisabled = true;
  }

  clearData() {
    this.ngOnInit();

    this.appliedRoute = false;
    this.point1x = '';
    this.point1y = '';
    this.point1coordsys = '';
    this.point2x = '';
    this.point2y = '';
    this.point2coordsys = '';
    this.points = '';
    this.point3x = '';
    this.point3y = '';
    this.point3coordsys = '';
    $('#optTimeLabel').addClass('active');
    $('#optDistanceLabel').removeClass('active');
    this.isDisabled = true;
    this.dataCleared = true;
    if (this.dataCleared && this.mapCleared) {
      this.isDisabled = true;
    }
    this.height = '';
    this.length = '';
    this.width = '';
    this.weight = '';
    this.isUseCVROptions = false;
    this.avoidTollRoads = false;
    this.optimizeBy = 'time';
  }

  clearMap() {
    this.layerGroups.clearLayers();
    this.isDisabled = false;
    this.mapCleared = true;
    if (this.dataCleared && this.mapCleared) {
      this.isDisabled = true;
    }
  }

  setDirectionsStyle(value) {
    this.directionsStyle = value;
  }

  constructGetRouteURL() {

    let coordsys1;
    let coordsys2;
    if (this.point1coordsys) {
      coordsys1 = this.point1coordsys;
    } else {
      coordsys1 = this.point1coordsys = 'epsg:4326';
    }
    if (this.point2coordsys) {
      coordsys2 = this.point2coordsys;
    } else {
      coordsys2 = this.point2coordsys = 'epsg:4326';
    }
    let database;
    if (this.selectedDBName) {
      database = this.selectedDBName;
    } else {
      database = this.selectedDBName = 'Default';
    }
    if (database === '') {
      this.errorDialogService.showErrorDialog('Please configure a database.');
    }
    let languageParam = '';
    if (this.directionsStyle === 'Normal') {
      languageParam = 'language=' + this.selectedLanguage + '&';
    }

    const baseURL = this.routingDemoPageService.getBaseUrl();


    let url = '/databases/' + database + '.json?q=route' + '&' +
      'startPoint=' + this.point1x + ',' + this.point1y + ',' + coordsys1 + '&' +
      'endPoint=' + this.point2x + ',' + this.point2y + ',' + coordsys2 + '&' +
      'returnIntermediatePoints=true' + '&' +
      'segmentGeometryStyle=All' + '&' +
      'directionsStyle=' + this.directionsStyle + '&' +
      languageParam +
      'primaryNameOnly=' + this.primaryNameOnly + '&' +
      'majorRoads=' + this.majorRoadsOnly + '&' +
      'distanceUnit=' + this.selectedDistanceUnit + '&' +
      'timeUnit=' + this.selectedTimeUnit + '&' +
      'oip=' + this.oip +
      '&localRoadsLoadFactor=' + this.selectedLocalRoadsLoadFactor +
      '&historicTrafficTimeBucket=' + this.selectedHistoricTimeBucketB;

    if (this.avoidTollRoads) {
      url += '&avoid=tollRoad';
    }
    if (this.optimizeBy != 'time') {
      url += '&optimizeBy=distance';
    }else{
      url += '&optimizeBy=time';
    }
    this.restRouteRequest = this.routingDemoPageService.serverAndPort(baseURL, url);
    this.methodType = 'GET';
    return baseURL + url;
  }

  constructRouteInstructions(response) {
    let instructions = '<div  class="total-time-distance">' + 'Total time: ' + response.time + ' ' + response.timeUnit +
      '</div>' + '<div class="total-time-distance">' + 'Total distance: ' + response.distance + ' ' + response.distanceUnit + '</div>';
    if (this.directionsStyle === 'Normal') {
      const directions = response.routeDirections;
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < directions.length; i++) {
        if (directions[i].instruction !== '') {
          instructions += '<div class="instruction-padding"><i class="fa fa-arrow-circle-right" ' +
            'style="font-size:36px"></i>  ' + directions[i].instruction + '</div>';
        }
      }
    }
    return instructions;
  }

  // tslint:disable-next-line:max-line-length
  processRouteRequest(count, noOfColors, response, randomcolor, startlongitude, startlatitude, endlatitude, endlongitude, intermediatePointsX, intermediatePointsY) {
    this.isDisabled = false;
    this.showRouteReqDiv = true;
    this.routeInstructions = this.constructRouteInstructions(response);
    if (count < noOfColors) {
      randomcolor = GEOMETERS[Math.floor(Math.random() * noOfColors)];
    }
    if (count >= noOfColors) {
      randomcolor = GEOMETERS[Math.floor(Math.random() * noOfColors)];
    }
    const geoJSONGeometry = response.geometry;
    const geoJSONLayer = L.geoJson(geoJSONGeometry, {
      style: {
        color: randomcolor,
        weight: 3.5
      }
    });
    this.layerGroups.addLayer(geoJSONLayer);
    this.map.fitBounds(geoJSONLayer.getBounds(), {
      padding: [20, 20]
    });

    if (intermediatePointsX && intermediatePointsY != null) {
      const greenIcon = new L.Icon({
        iconUrl: './assets/marker-icon-2x-green.png',
        shadowUrl: './assets/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]

      });
      const ipsArray = response.intermediatePoints.coordinates;
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < ipsArray.length; i++) {
        const point = ipsArray[i];
        const intermediatePointLayer = L.marker([point[1], point[0]], {icon: greenIcon}).addTo(this.map);
        this.layerGroups.addLayer(intermediatePointLayer);
      }
    }
    const redIcon = new L.Icon({
      iconUrl: './assets/marker-icon-2x-red.png',
      shadowUrl: './assets/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]

    });
    const endPointLayer = L.marker([endlatitude, endlongitude], {icon: redIcon}).addTo(this.map);
    const startPointLayer = L.marker([startlatitude, startlongitude]).addTo(this.map);
    this.layerGroups.addLayer(endPointLayer);
    this.layerGroups.addLayer(startPointLayer);
    this.map.spin(false);
    this.isApplyButtonDisabled = false;
    this.isDisabled = false;
    this.routingDemoPageService.gotoElement('routeOutput');

  }

  processRouteError(errorRes) {
    this.map.spin(false);
    this.isApplyButtonDisabled = false;
    this.isDisabled = false;
    if (!String.prototype.startsWith) {
      String.prototype.startsWith = function(searchString, position) {
        position = position || 0;
        return this.indexOf(searchString, position) === position;
      };
    }
    if (errorRes.error.value != null) {
      this.errorDialogService.showErrorDialog(errorRes.error.value);
    } else if (errorRes.error.startsWith('<html>')) {
      this.errorDialogService.showErrorDialog('Invalid User Name or Password');
    }
  }

  constructPostBody() {
    const json = {};
    const UseIntermediate = this.points;
    if (UseIntermediate) {
      const intermediatePoints = {};
      const tp = 'type';
      intermediatePoints[tp] = this.type;
      const crs = {};
      crs[tp] = this.crstype;
      const properties = {};
      const nm = 'name';
      properties[nm] = this.epsg;
      let coordinates = [];
      const temparray = {};

      try {
        for (let i = 0; i <= JSON.parse('[' + this.points + ']').length - 1; i++) {

          const temp = [];
          temp.push(JSON.parse('[' + this.points + ']')[i]);
          i = i + 1;
          temp.push(JSON.parse('[' + this.points + ']')[i]);
          temparray[i] = temp;
        }
      } catch (error) {
        console.log(' — Error ', error.message);
      }
      coordinates = $.map(temparray, (value, index) => {
        return [value];
      });
      const cs = 'crs';
      intermediatePoints[cs] = crs;
      const prop = 'properties';
      crs[prop] = properties;
      const cd = 'coordinates';
      intermediatePoints[cd] = coordinates;
      const ip = 'intermediatePoints';
      json[ip] = intermediatePoints;
    }
    const isUseCVR = this.isUseCVROptions;
    if (isUseCVR) {

      const cvr = {};
      const lb = 'looseningBarrierRestrictions';
      cvr[lb] = this.selectLooseningBarrierRestriction;

      const vehicleAttributes = {};
      const vt = 'vehicleType';
      vehicleAttributes[vt] = this.selectedVehicleTypes;

      if ((this.height)) {
        if (!(this.height === '')) {
          const hu = 'heightUnit';
          const h = 'height';
          vehicleAttributes[hu] = this.selectedHeightUnits;
          vehicleAttributes[h] = this.height;
        }

      }

      if ((this.length)) {
        if (!(this.length === '')) {
          const lu = 'lengthUnit';
          const l = 'length';
          vehicleAttributes[lu] = this.selectedLengthUnits;
          vehicleAttributes[l] = this.length;
        }
      }

      if ((this.width)) {
        if (!(this.width === '')) {
          const wu = 'widthUnit';
          const w = 'width';
          vehicleAttributes[wu] = this.selectedWidthUnits;
          vehicleAttributes[w] = this.width;
        }
      }

      if ((this.weight)) {
        if (!(this.weight === '')) {
          const weu = 'weightUnit';
          const we = 'weight';
          vehicleAttributes[weu] = this.selectedWeightUnits;
          vehicleAttributes[we] = this.weight;
        }
      }
      const va = 'vehicleAttributes';
      cvr[va] = vehicleAttributes;
      const cr = 'cvr';
      json[cr] = cvr;
    }

    const postBody = JSON.stringify(json);
    this.requestPostBody = postBody;
    this.methodType = 'POST';
    return postBody;
  }

  getRoute(isRouteFormValid) {
    this.appliedRoute = true;
    if (isRouteFormValid) {
      const startlongitude = this.point1x;
      const startlatitude = this.point1y;

      const endlongitude = this.point2x;
      const endlatitude = this.point2y;

      const intermediatePointsX = this.point3x;
      const intermediatePointsY = this.point3y;

      if (this.username) {

        this.user = this.username;
      }
      if (this.password) {

        this.userPasswod = this.password;
      }

      const serviceURL = this.constructGetRouteURL();
      let postBody = '';
      const UseIntermediate = this.points;
      const isUseCVR = this.isUseCVROptions;

      if (UseIntermediate !== '' && isUseCVR === undefined) {
        postBody = this.constructPostBody();
      } else if (UseIntermediate) {
        postBody = this.constructPostBody();
      } else if (isUseCVR) {
        postBody = this.constructPostBody();
      }
      let count = 0;
      const noOfColors = GEOMETERS.length;
      const randomcolor = '';
      this.map.spin(true);
      this.isApplyButtonDisabled = true;
      this.isDisabled = true;
      if (postBody != null && postBody !== '') {
        this.routingDemoPageService.executePostService(serviceURL, postBody, this.user, this.userPasswod).subscribe((response) => {

          this.processRouteRequest(count, noOfColors, response, randomcolor, startlongitude, startlatitude,
            endlatitude, endlongitude, intermediatePointsX, intermediatePointsY);
          count++;
        }, (error) => {

          this.processRouteError(error);

        });
      } else {
        this.routingDemoPageService.executeService(serviceURL, this.username, this.password).subscribe((response) => {

          // tslint:disable-next-line:max-line-length
          this.processRouteRequest(count, noOfColors, response, randomcolor, startlongitude, startlatitude, endlatitude, endlongitude, null, null);
          count++;
        }, (error) => {

          this.processRouteError(error);

        });
      }
    }
  }


  setMapContentForRoute() {
   /* this.points = '';*/
    this.map.closePopup();
    this.map.on('contextmenu')._events.contextmenu = [];
    this.map.on('contextmenu', (e1) => {

      const x = e1.latlng.lng;
      const y = e1.latlng.lat;
      const scope = this;

      const routeRightClickText = $('<div/>').html('<div> <div class="map-popup" ' +
        'style="height: 20px; cursor: pointer;border: 0" id="startPoint">Start Point</div>' +
        '<div style="margin-top: 10%"></div>' +
        '<div class="map-popup" style="height: 20px; cursor: pointer;border: 0" id="intermediatePoint">Intermediate Point' +
        '<div style="margin-top: 15%"></div>' +
        '</div>' + '<div class="map-popup"' +
        ' style="height: 20px; cursor: pointer;margin-top: 10%; border: 0" id="endPoint">End Point</div> </div>').contents()[0];
      L.popup().setLatLng(e1.latlng).setContent(routeRightClickText).openOn(this.map);
      $('#startPoint').on('click', () => {
        scope.point1x = x.toFixed(6);
        scope.point1y = y.toFixed(6);
        this.validateStartLongitude();
        this.validateStartLatitude();
        this.ref.detectChanges();
        this.map.closePopup();
      });

      $('#endPoint').on('click', () => {
        scope.point2x = x.toFixed(6);
        scope.point2y = y.toFixed(6);
        this.validateEndLongitude();
        this.validateEndLatitude();
        this.ref.detectChanges();
        this.map.closePopup();
      });

      $('#intermediatePoint').on('click', () => {
        scope.point3x = x.toFixed(6);
        scope.point3y = y.toFixed(6);
        if (this.points.length === 0) {
          this.points = scope.point3x + ',' + scope.point3y;
        } else {
          this.points = this.points.concat(',').concat(scope.point3x + ',' + scope.point3y);
        }
        this.ref.detectChanges();
        this.map.closePopup();
      });
    });
  }
}
